/**
 * [小运力公司管理] -> 站点信息
 * @author: Fu Xiaochun
 * @date: 2022-05-26 
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message, Button, Select } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XSelect, XOKButton, XCancelButton, XRangePicker, } from '@/components/xqxc_ui';
import TableContent from './components/tableContent';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import * as apis from '@/apis/operation/transportCompany';
import getEnumData from '@/helpers/getEnumData';
import { autoPageNum, autopageSize } from '@/assets/config';
import CreateTransportCompany from './components/CreateTransportCompany';
import ButtonPerssion from '@/routes/ButtonPerssion';

const { Option } = Select;

function TransportCompany(props) {

    const [orderData, setOrderData] = useState({});
    const page = useRef({ pageNum: autoPageNum, pageSize: autopageSize });
    const [aliveInit, setAliveInit] = useState(false);
    const [reset, setReset] = useState();

    const [companyKey, setCompanyKey] = useState();  // 运力公司名/id
    const [contactName, setContactName] = useState();  // 联系人姓名
    const [settleModel, setSettleModel] = useState({});  // 结算模式
    const [companyStatus, setCompanyStatus] = useState({});  // 公司协议状态
    const [expirationTime, setExpirationTime] = useState([]);  // 协议有效期查询时间

    const [settleModelEnum, setSettleModelEnum] = useState([]);  // 结算模式枚举
    const [companyStatusEnum, setCompanyStatusEnum] = useState([]);  // 状态枚举
    const [areaOperateEnum, setAreaOperateEnum] = useState([]);  // 区域运营枚举
    const [accountOpeningStatusEnum, setAccountOpeningStatusEnum] = useState([]);  // 开户状态枚举
    const [areaOperate, setAreaOperate] = useState({});  // 区域运营
    const [accountOpeningStatus, setAccountOpeningStatus] = useState({});  // 开户状态

    const [editId, setEditId] = useState(0);
    const [createModalVisible, setCreateModalVisible] = useState(false); // 新建运力公司弹窗显示

    const $ocPage = useRef({ pageNum: 1, pageSize: 10 });
    const ocLoading = useRef(false);
    const [OCList, setOCList] = useState([]);   //运营中心列表
    const [OC, setOC] = useState({});  // 运营中心

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
        getEnumData('TransportSettleModeEnum', setSettleModelEnum);
        getEnumData('SmallTransportStatusEnum', setCompanyStatusEnum);
        getEnumData('SmallTransZoneOperationEnum', setAreaOperateEnum);
        getEnumData('SmallTransAccountOpeningStatusEnum', setAccountOpeningStatusEnum);
        getOperatingCenterList();  // 搜索运营中心
    }, []);

    useEffect(() => {
        aliveInit && onSearch('usecache');
    }, [aliveInit]);

    useEffect(() => {
        reset && onSearch();
    }, [reset]);

    const initData = (data) => {
        setAliveInit(true);
        setCompanyKey(data.transportNameOrId);
        setContactName(data.contactName);
        setSettleModel({ ...data.settleModel });
        setCompanyStatus({ ...data.companyStatus });
        setExpirationTime(data.expirationTime ? [...data.expirationTime] : []);
        page.current = { pageNum: data.pageNum, pageSize: data.pageSize };
    };

    const getOperatingCenterList = (data = {}) => {
        let params = {
            companyName: data.companyName,
            pageSize: $ocPage.current.pageSize,
            pageNum: $ocPage.current.pageNum
        };
        apis.getOperatingCenterList(params).then(res => {
            let list = [...OCList];
            let _list = res.result.dataList || [];

            if ($ocPage.current.pageNum > 1) {
                list = list.concat(..._list);
            } else {
                list = _list;
            }
            // list = list.map(v => ({ value: v.companyName, code: v.companyId }));
            setOCList(list);
        }).catch(err => {
            message.error(err.message);
        });
    };

    const onOCListScroll = (e) => {
        e.persist();
        const { target } = e;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            if (!ocLoading.current) {
                $ocPage.current.pageNum = $ocPage.current.pageNum + 1;
                getOperatingCenterList();
            }
        }
    };

    const onOCListSearch = (val) => {
        let reg = /^[\u4e00-\u9fa5]{1,40}$/;
        $ocPage.current.pageNum = 1;
        if (reg.test(val)) {
            getOperatingCenterList({ companyName: val });
        } else {
            getOperatingCenterList();
        }
    };

    const onOCListFocus = (e) => {
        e.target.scrollTop = 0;
        $ocPage.current.pageNum = 1;
        getOperatingCenterList();
    };

    // 查询
    const onSearch = (usecache) => {
        console.log(OC);
        if (usecache !== 'usecache') {
            page.current = { pageNum: autoPageNum, pageSize: autopageSize };
        }
        let searchCache = {
            transportNameOrId: companyKey,
            contactName: contactName,
            settleType: settleModel.code,
            status: companyStatus.code,
            zoneOperation: areaOperate.code,
            accountOpeningStatus: accountOpeningStatus.code,
            agrtStartTime: expirationTime[0] ? expirationTime[0] + ' 00:00:00' : undefined,
            agrtEndTime: expirationTime[1] ? expirationTime[1] + ' 23:59:59' : undefined,
            opId: OC.value,
            pageNum: page.current.pageNum,
            pageSize: page.current.pageSize,
        };

        apis.getSmallTransportList(searchCache).then(res => {
            setOrderData(res.result);
        }).catch(err => {
            message.error(err.message);
        });
        KeepAlive.saveCache({ ...searchCache, expirationTime, settleModel, companyStatus }); // 【第3步，缓存查询状态】
    };

    const onReset = () => {
        setCompanyKey();
        setContactName();
        setContactName();
        setSettleModel({});
        setCompanyStatus({});
        setExpirationTime([]);
        setOC({});
        setReset(Date.now());
        setAreaOperate({});
        setAccountOpeningStatus({});
        page.current = { pageNum: autoPageNum, pageSize: autopageSize };
    };

    const tableAction = (type, item) => {
        switch (type) {
            case 'detail':
                // 跳转详情
                props.history.push('/home/operation/transportCompany/detail/' + item.id);
                break;
            case 'edit':
                // 修改
                setEditId(item.id);
                setCreateModalVisible(true);
                break;
            default:
            // nothing to do
        }
    };

    const onPageChange = (pageSize, pageNum) => {
        page.current = { pageNum, pageSize };
        onSearch('usecache');
    };

    // 新建小运力公司
    const createTransportCompany = () => {
        setEditId(0);
        setCreateModalVisible(true);
    };

    const onCreateOk = () => {
        setCreateModalVisible(false);
        onReset();
    };

    return (
        <KeepAlive render={(state) => {
            if (!aliveInit) {
                initData(state);
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            inputStyle={{ width: '180px' }}
                            label='站点名称/ID'
                            placeholder='请输入站点名称/ID'
                            value={companyKey}
                            bindThis={setCompanyKey}
                            bindName='companyKey'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XInput
                            inputStyle={{ width: '140px' }}
                            label='联系人'
                            placeholder='请输入联系人姓名'
                            value={contactName}
                            bindThis={setContactName}
                            bindName='contactName'
                            maxLength={10}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            selectStyle={{ width: '120px' }}
                            label='结算模式'
                            placeholder='请选择'
                            renderData={settleModelEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={settleModel.value}
                            bindThis={setSettleModel}
                            bindName='settleModel'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            selectStyle={{ width: '120px' }}
                            label='站点状态'
                            placeholder='请选择'
                            renderData={companyStatusEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={companyStatus.value}
                            bindThis={setCompanyStatus}
                            bindName='companyStatus'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XRangePicker
                            style={{ marginRight: '20px' }}
                            label='协议有效期'
                            bindThis={setExpirationTime}
                            bindName='expirationTime'
                            value={expirationTime}
                            format="YYYY-MM-DD"
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            selectStyle={{ width: '120px' }}
                            label='区域运营'
                            placeholder='请选择'
                            renderData={areaOperateEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={areaOperate.value}
                            bindThis={setAreaOperate}
                            bindName='areaOperate'
                        />
                    </SearchItem>
                    <SearchItem>
                        <div className={styles.searchItemOC}>
                            <div className={styles.label}>运营中心</div>
                            <div className={styles.val}>
                                <Select placeholder='请选择' className={styles.selectInput} allowClear showSearch
                                    onFocus={onOCListFocus}
                                    onSearch={onOCListSearch}
                                    onPopupScroll={onOCListScroll}
                                    onChange={val => { setOC(val || {}); }}
                                    value={OC}
                                    optionFilterProp="children"
                                    labelInValue={true}
                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                >
                                    {OCList.map((item, index) => <Option key={item.companyId} value={item.companyId} >{item.companyName}</Option>)}
                                </Select>
                            </div>
                        </div>
                    </SearchItem>
                    {/* <SearchItem>
                        <XSelect
                            selectStyle={{ width: '120px' }}
                            label='开户状态'
                            placeholder='请选择'
                            renderData={accountOpeningStatusEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={accountOpeningStatus.value}
                            bindThis={setAccountOpeningStatus}
                            bindName='accountOpeningStatus'
                        />
                    </SearchItem> */}
                    <SearchItem>
                        <XOKButton
                            style={{ marginRight: '20px', width: '60px' }}
                            label='查询'
                            onClick={onSearch}
                        />
                        <XCancelButton
                            style={{ marginRight: '20px', width: '60px' }}
                            label='重置'
                            onClick={onReset}
                        />
                    </SearchItem>
                </SearchBox>
                <div className={styles.handleBox}>
                    <ButtonPerssion code='operation/transportCompany/createZDBtn'><Button type="primary" onClick={createTransportCompany}>新建</Button></ButtonPerssion>
                </div>
                <TableContent renderData={orderData} tableAction={tableAction} paginationChange={onPageChange} />
                {createModalVisible && <CreateTransportCompany editId={editId} onOk={onCreateOk} onClose={() => { setCreateModalVisible(false); }} />}
            </div>
        </KeepAlive>
    );
}

TransportCompany.propTypes = {
    setBreadcrumbPaths: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object
};

export default connect((state) => ({ ...state }), { setBreadcrumbPaths })(TransportCompany);